module.exports = __webpack_public_path__ + "img/trainersignup-02.43b8197d.png";